import React from 'react';
import { connect } from 'react-redux';

const mapState = (state) => {
    return {
        familiar : state.af.familiar,
        paso: state.af.pasoInvitado,
    };
}

const mapDispatch = (dispatch) => {
    return {
		pasoInvitado: (paso) => {
			dispatch({ "type": "AF_EDITAR_PASO_INVITADO", "pasoInvitado": paso });
		}
    }
}

class InvitadoEliminado extends React.Component {

	close = () => {
        $("#modal-gestionar").modal("hide");
		this.props.pasoInvitado(0);
	}

    render() {
        return (
            <div>
                <img src={ require("../img/icon-send.svg") }/>
                <h5 className="invitacion-title">Invitado eliminado</h5>
                <p>¡Listo! El usuario {this.props.familiar.nombre} ha sido eliminado satisfactoriamente.</p>
                <div className="text-center aceptar-cancelar-btn mt-38 mb-20">
                    <a onClick={this.close.bind(this)} className="orange-btn">Aceptar</a>
                </div>
            </div>
        );
	}
}

export default connect(mapState, mapDispatch)(InvitadoEliminado);



// WEBPACK FOOTER //
// ./src/acceso-familiar/InvitadoEliminado.cmpt.js